var path = 'app/scripts/modules/core/src/projects/dashboard/executionRefresh.tooltip.html';
var html = "<p ng-if=\"vm.state.refreshing\">Pipeline data is <strong>refreshing</strong>.</p>\n<p ng-if=\"!vm.state.refreshing\">(click <span class=\"fa fa-refresh\"></span> to refresh)</p>\n<p>Last refresh:<br> {{vm.state.lastRefresh | timestamp }} <br> ({{vm.state.lastRefresh | relativeTime }})</p>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/projects/dashboard/executionRefresh.tooltip.html
// module id = 1117
// module chunks = 0